export default __webpack_public_path__ + "static/productImg-7a477a7d0bf09c3e9c6763cb53f352f7.png";